export default function ($container = $(document)) {
    $container.find(`[data-wysiwyg-blog]`);
    const heading = $container.find(`[data-wysiwyg-blog] #heading`);
    const animation = $container.find(`[data-sprite-animation]`);
    heading.append(animation);

    const blog = document.querySelector('[data-wysiwyg-blog] #heading');

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (typeof getCurrentAnimationPreference === 'function' && !getCurrentAnimationPreference()) {
                return;
            }
            if (entry.isIntersecting) {
                if( $container.find(`.sprite`)) {
                    $container.find(`.sprite`).addClass('is-show');
                    $container.find(`.sprite__tooltip`).show('slow');
                }
            } else {
                if( $container.find(`.sprite`)) {
                    $container.find(`.sprite`).removeClass('is-show');
                    $container.find(`.sprite__tooltip`).show('slow');
                }
            }
        });
    });
    observer.observe(blog);
}



// WEBPACK FOOTER //
// ./src/js/_modules/sprite.js